import { createFileRoute, Link } from '@tanstack/react-router';

import { Skeleton } from '~/components/shadcn/skeleton.tsx';
import { useTranslations } from '~/i18n/use-translations.ts';
import { WebPushSettings } from '~/modules/push-notifications/WebPushSettings.tsx';
import { requireAuthenticatedBeforeLoad } from '~/routing/require-authenticated-before-load.ts';
import { cn } from '~/utils/cn.ts';
import { ClientOnly } from '~/utils/is-browser.tsx';

export const Route = createFileRoute('/push-notifications-poc')({
	beforeLoad: requireAuthenticatedBeforeLoad,
	component: PushNotificationsPoc,
});

function PushNotificationsPoc() {
	const t = useTranslations();
	return (
		<main className="flex min-h-dvh w-full justify-center bg-background px-4 py-10 text-foreground">
			<div className="flex w-full max-w-xl flex-col gap-y-6">
				<div className="flex flex-col gap-y-2">
					<h1 className="font-semibold text-2xl">{t('pushPoc.title')}</h1>
					<p className="text-muted-foreground text-sm">{t('pushPoc.description')}</p>
				</div>

				<ClientOnly fallback={<Skeleton />}>{() => <WebPushSettings />}</ClientOnly>

				<Link
					className={cn(
						'mr-auto inline-flex h-8 items-center border border-border px-2.5',
						'font-medium text-muted-foreground text-xs hover:bg-muted hover:text-foreground',
					)}
					preload="intent"
					to="/user/notifications"
				>
					{t('pushPoc.openSettings')}
				</Link>
			</div>
		</main>
	);
}
